import React, { Component } from 'react'
import CustomModal from '../../shared/CustomModal';

export default class ConsolidatedErrorModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleErrorModalDetails: false,
            errorsList: props?.data?.Content?.Data ? JSON.parse(props.data.Content.Data) : {}
        }
    }

    viewErrors = (e) => {
        e.preventDefault();
        this.setState({ toggleErrorModalDetails: true });
    }

    closeModal = () => {
        this.setState({ toggleErrorModalDetails: false });
    }

    render() {
        const { toggleErrorModalDetails, errorsList } = this.state;
        return (
            <>
                <button data-testid="btn-link" className="btn btn-link" onClick={(e) => this.viewErrors(e)}>View Errors</button>
                <CustomModal
                    id="consolidated-error-modal"
                    show={toggleErrorModalDetails}
                    title="Consolidated Error List"
                    isComponent={true}
                    dialogClassName="consolidated-error-dialog"
                    closeAction={this.closeModal}>
                    <div className="error-viewbox">
                        <ul>
                            {Object.keys(errorsList).map((x, i) => {
                                return (
                                    <li className="my-1" key={`case-id-${i}`}>{parseFloat(x) ? 'Plan ID: ' : '' }<strong>{x}</strong>
                                        <ul key={`error-list-id-${i}`}>
                                            {Array.isArray(errorsList[x]) ?
                                                errorsList[x].map((y, j) => {
                                                    return <li key={`error-id-${j}`}>{y}</li>
                                                }) : <li key={`error-id-${i}`}>{errorsList[x]}</li>}
                                        </ul>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </CustomModal>
            </>
        )
    }
}
